import cl from "./PumpGroup.module.css"
const PumpGroup = ({children}) => {
  return (
    <div className={cl.pumpGroup}>{children}</div>
  )
}

export default PumpGroup